import { Outlet, Route, Routes } from 'react-router-dom'
import { AboutPage } from './aboutPage/aboutPage'
import { AccessRequests } from './accessRequestsPage/AccessRequestsPage'
import { AccountPage } from './accountPage/accountPage'
import { ChangeOrgPage } from './changeOrg/changeOrgPage'
import { CreditsPage } from './creditPage/creditsPage'
import { DeleteAccountPage } from './deleteAccountPage/deleteAccountPage'
import { ItineraryPage } from './itinerariesPage/itineraryPage'
import LanguagePage from './languagePage/languagePage'
import { LicensesPage } from './licensesPage/licensesPage'
import { EditDetailsPage } from './profilePage/editDetailsPage'
import { ProfilePage } from './profilePage/profilePage'
import SettingsPage from './settingsPage/settingsPage'
import ThemesPage from './themePage/themePage'
import { TimePage } from './timePage/timePage'
import LocalNotificationsPage from './localNotificationsPage/localNotificationsPage'
import { PendingNotificationsView } from './localNotificationsPage/pendingNotificationsPage'

export const AccountRouter = () => {
    return (
        <Routes>
            <Route key={'1'} index element={<AccountPage />} />

            <Route key={'2'} path={'/profile/*'} element={<Outlet />}>
                <Route key={'1'} index element={<ProfilePage />} />

                <Route
                    key={'2'}
                    path={'delete'}
                    element={<DeleteAccountPage />}
                />

                <Route key={'3'} path={'edit'} element={<EditDetailsPage />} />
            </Route>
            <Route key={'3'} path={'/about'} element={<AboutPage />} />

            <Route key={'4'} path={'/licenses'} element={<LicensesPage />} />

            <Route key={'5'} path={'/credits'} element={<CreditsPage />} />

            <Route key={'6'} path={'/changeOrg'} element={<ChangeOrgPage />} />

            <Route
                key={'7'}
                path={'/accessRequests'}
                element={<AccessRequests />}
            />

            <Route key={'8'} path={'/settings'} element={<SettingsPage />} />

            <Route
                key={'9'}
                path={'/itineraries'}
                element={<ItineraryPage />}
            />

            <Route key={'10'} path={'/themes'} element={<ThemesPage />} />

            <Route key={'11'} path={'/languages'} element={<LanguagePage />} />

            <Route key={'11'} path={'/time'} element={<TimePage />} />

            <Route
                key={'12'}
                path={'/local-notifications'}
                element={<LocalNotificationsPage />}
            />

            <Route
                key={'13'}
                path={'/local-notifications/pending'}
                element={<PendingNotificationsView />}
            ></Route>
        </Routes>
    )
}
